import Swiper from "swiper";
import { Pagination } from "swiper/modules";
Swiper.use([Pagination]);

export function initReferencesSlider() {
  const employeeSlider = document.querySelectorAll(
    ".mb-single-reference-slider"
  );

  let employeeSwiper = [];

  for (let i = 0; i < employeeSlider.length; i++) {
    employeeSwiper[i] = new Swiper(employeeSlider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        920: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}
